import ElementPlus from 'element-plus';
import './styles/index.scss';

export default ElementPlus;
